/**
 * Shared auth form tokens for Clerk (sign-in/sign-up) and forgot-password page.
 * Aligned with packages/components (Input, Button) and packages/themes.
 */

export const authFormTokens = {
    colors: {
        border: '#e7e5e4',
        borderFocus: 'var(--amber10)',
        borderFocusRing: 'rgba(217, 119, 6, 0.25)',
        foreground: '#1c1917',
        mutedForeground: '#57534e',
        primary: '#b45309',
        primaryForeground: '#fffbeb',
        primaryHover: '#92400e',
        primaryButtonBackground: 'var(--amber10)',
        primaryButtonForeground: '#ffffff',
        /* Match Button primary: hoverStyle uses $amber9 (lighter than default amber10) */
        primaryButtonHover: '#d97706',
        background: '#ffffff',
        inputBg: 'transparent',
        muted: '#fafaf9',
        danger: '#dc2626',
    },
    sizing: {
        inputMinHeight: 40,
        inputBorderRadius: 12,
        inputPaddingVertical: 8,
        inputPaddingHorizontal: 12,
        buttonMinHeight: 40,
        buttonBorderRadius: 8,
        buttonPaddingVertical: 10,
        buttonPaddingHorizontal: 12,
    },
    typography: {
        fontFamily: '"Nunito Sans", sans-serif',
        fontFamilyButtons: '"Nunito", sans-serif',
        labelFontSize: '0.875rem',
        labelFontWeight: 600,
        inputFontSize: 16,
        buttonFontSize: 16,
        buttonFontWeight: 600,
        linkFontSize: '0.875rem',
        linkFontWeight: 500,
        headerTitleFontSize: '1.25rem',
        headerTitleFontWeight: 600,
        headerSubtitleFontSize: '0.875rem',
    },
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
} as const;
